// extracted by mini-css-extract-plugin
export default {"remainingText":"TS8a5VZnq5EK7qjBLDVQ"};